'use client';

import { useState, useCallback } from 'react';
import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';

import ButtonLink from '@/components/ui/ButtonLink';
import LanguageSwitcher from '@/components/ui/LanguageSwitcher';
import MenuButton from '@/features/header/MenuButton';
import { MenuItem } from '@/features/header/NavList';
import { COMMON_I18N } from '@/lib/i18n/commonI18n';

const MobileMenu = dynamic(() => import('@/features/header/MobileMenu'), {
  ssr: false,
});

const HeaderClient = ({ items, featured }: HeaderClientProps) => {
  const [open, setOpen] = useState(false);
  const { locale: raw } = useParams<{ locale?: string }>();
  const locale = raw === 'en' ? 'en' : 'pt';
  const t = COMMON_I18N[locale];

  const toggle = useCallback(() => setOpen((v) => !v), []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <>
      <div className="hidden desktop:flex items-center gap-6">
        {featured && (
          <ButtonLink href={featured.href}>{featured.name}</ButtonLink>
        )}
        <LanguageSwitcher />
      </div>

      <div className="desktop:hidden">
        <MenuButton
          isOpen={open}
          onClick={toggle}
          openLabel={t.openMenu}
          closeLabel={t.closeMenu}
        />

        <MobileMenu
          open={open}
          onClose={close}
          items={items}
          featured={featured}
        />
      </div>
    </>
  );
};

export default HeaderClient;

type HeaderClientProps = {
  items: MenuItem[];
  featured?: MenuItem;
};
